// #region imports

// --- Angular
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

// --- RxJs
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

// --- 3rd Party
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// --- HS Code
import { SurveySummaryModel } from '../../../models';
import { CompareReportBaseService } from '../../../core/services';

// #endregion

@Component({
  selector: 'hs-compare-report-modal',
  templateUrl: './compare-report-modal.component.html',
  styleUrls: ['./compare-report-modal.component.scss'],
})
export class CompareReportModalComponent implements OnInit, OnChanges, OnDestroy {
  @Input() selectedSurvey: SurveySummaryModel | null = null;

  campaigns$: Observable<SurveySummaryModel[] | null>;
  selectedCampaign$: Observable<SurveySummaryModel | null>;
  campaignsLoading$: Observable<boolean>;

  private _selectedCampaignSubscription: Subscription = Subscription.EMPTY;

  constructor(
    private activeModal: NgbActiveModal,
    private compareReportService: CompareReportBaseService
  ) {
    this.campaigns$ = this.compareReportService.campaigns$;
    this.campaignsLoading$ = this.compareReportService.campaignsLoading$;
    this.selectedCampaign$ = this.compareReportService.selectedCampaign$;
  }

  ngOnInit() {
    this.compareReportService.loadCampaigns(this.selectedSurvey?.id ?? '');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes &&
      changes['selectedSurvey'] &&
      changes['selectedSurvey'].currentValue
    ) {
      const selectedSurveyId = changes['selectedSurvey'].currentValue.id;
      this.compareReportService.loadCampaigns(selectedSurveyId);
    }
  }

  ngOnDestroy() {
    if (this._selectedCampaignSubscription) {
      this._selectedCampaignSubscription.unsubscribe();
    }
  }

  onDismissModalClicked() {
    this.activeModal.dismiss();
  }

  onSelectCampaign(campaign: SurveySummaryModel) {
    this.compareReportService.selectCampaign(campaign);
  }

  compareClick() {
    this._selectedCampaignSubscription = this.selectedCampaign$
      .pipe(take(1))
      .subscribe((campaign) => {
        if (this._selectedCampaignSubscription) {
          this._selectedCampaignSubscription.unsubscribe();
        }
        this.activeModal.close(campaign);
      });
  }
}
